import { useCallback, useRef } from "react"

import useEntityChangeSubscription from "./useEntityChangeSubscription.jsx"

/*
 * Consumer: neue reported Waypoints -> bestehenden Refresh-Seam bumpen.
 * Gate: nur wenn reported überhaupt angezeigt wird, und bei selektiertem
 * Vessel nur für genau dieses — der Refetch dahinter ist teuer
 * (GeoJSON + Worker + Leaflet-Rebuild).
 */
export default function useReportedChangeRefresh({ selectedVesselId, switchReported, onChanged }) {
  const gateRef = useRef({ selectedVesselId, switchReported })
  gateRef.current = { selectedVesselId, switchReported }

  const handleBatch = useCallback(
    ({ entries, reset }) => {
      const gate = gateRef.current
      const enabled = gate.selectedVesselId != null || gate.switchReported
      if (!enabled) return
      if (reset) {
        onChanged()
        return
      }
      const relevant = entries.some((entry) => {
        const vesselMatches =
          gate.selectedVesselId == null || entry.vesselId === gate.selectedVesselId
        if (!vesselMatches) return false
        if (entry.entityType === "waypoint") return true
        // route nur bei Anlage/Löschung — Updates (z.B. Umbenennung) ändern
        // am reported Track nichts.
        if (entry.entityType === "route") {
          return entry.ops?.includes("I") || entry.ops?.includes("D")
        }
        return false
      })
      if (relevant) onChanged()
    },
    [onChanged],
  )

  useEntityChangeSubscription(["waypoint", "route"], handleBatch)
}
